import type { TUser } from "@/types"
import { TeamTag } from "./Tags"

export function UserTeams({ user }: { user: TUser }) {
  if (!user.team_ids) return null
  return user.team_ids.map((teamId) => <TeamTag key={teamId} id={teamId} />)
}
